module.exports = __webpack_public_path__ + "img/case4.dd00f831.png";